import { googleKey } from "config/CONSTANTS";
export const BASE_URL = "https://teebica.com/backend/admin";
//export const BASE_URL = "http://127.0.0.1/teebica/admin";

export const urlUserLogin = BASE_URL + "/Main/login";

export const urlGetProfileInfo = BASE_URL + "/Profile/GetProfileInfo";
export const urlUpdateProfileInfo = BASE_URL + "/Profile/UpdateProfileInfo";

export const urlGetDashboardDetail = BASE_URL + "/DashBoard/GetDashboardDetail";

export const urlCreateImage = BASE_URL + "/Image/createImage";
export const urlUpdateImage = BASE_URL + "/Image/updateImage";
export const urlGetImageList = BASE_URL + "/Image/getImageList";
export const urlDeleteImage = BASE_URL + "/Image/deleteImage";
export const urlUpdateImagePosition = BASE_URL + "/Image/updateImagePosition";

export const urlCreateVideo = BASE_URL + "/Video/createVideo";
export const urlUpdateVideo = BASE_URL + "/Video/updateVideo";
export const urlGetVideoList = BASE_URL + "/Video/getVideoList";
export const urlDeleteVideo = BASE_URL + "/Video/deleteVideo";
export const urlUpdateVideoPosition = BASE_URL + "/Video/updateVideoPosition";

export const urlCreateRecipe = BASE_URL + "/Recipe/createRecipe";
export const urlUpdateRecipe = BASE_URL + "/Recipe/updateRecipe";
export const urlGetRecipeList = BASE_URL + "/Recipe/getRecipeList";
export const urlDeleteRecipe = BASE_URL + "/Recipe/deleteRecipe";
export const urlUpdateRecipePosition = BASE_URL + "/Recipe/updateRecipePosition";

export const urlCreateShopCategory = BASE_URL + "/ShopCategory/createCategory";
export const urlUpdateShopCategory = BASE_URL + "/ShopCategory/updateCategory";
export const urlGetShopCategoryList = BASE_URL + "/ShopCategory/getCategoryList";
export const urlGetAllShopCategories = BASE_URL + "/ShopCategory/getAllCategories";
export const urlDeleteShopCategory = BASE_URL + "/ShopCategory/deleteCategory";
export const urlUpdateShopCategoryPosition = BASE_URL + "/ShopCategory/updateCategoryPosition";

export const urlCreateShopProduct = BASE_URL + "/ShopProduct/createProduct";
export const urlUpdateShopProduct = BASE_URL + "/ShopProduct/updateProduct";
export const urlGetShopProductList = BASE_URL + "/ShopProduct/getProductList";
export const urlDeleteShopProduct = BASE_URL + "/ShopProduct/deleteProduct";
export const urlUpdateShopProductPosition = BASE_URL + "/ShopProduct/updateProductPosition";

export const urlGetSettings = BASE_URL + "/Setting/getSettings";
export const urlSaveSettings = BASE_URL + "/Setting/saveSettings";

export const urlGetShopOrderList = BASE_URL + "/ShopOrder/getOrderList";
export const urlGetShopOrderDetail = BASE_URL + "/ShopOrder/getOrderDetail";
export const urlUpdateShopOrderStatus = BASE_URL + "/ShopOrder/updateOrderStatus";
export const urlDeleteShopOrder = BASE_URL + "/ShopOrder/deleteOrder";
export const urlApproveShopOrder = BASE_URL + "/ShopOrder/approveOrder";

export const urlGetBuyerApplicationList = BASE_URL + "/ShopBuyer/getApplicationList";
export const urlGetBuyerApplicationDetail = BASE_URL + "/ShopBuyer/getApplicationDetail";
export const urlApproveBuyerApplication = BASE_URL + "/ShopBuyer/approveApplication";
export const urlRejectBuyerApplication = BASE_URL + "/ShopBuyer/rejectApplication";
export const urlSuspendBuyer = BASE_URL + "/ShopBuyer/suspendBuyer";
export const urlReactivateBuyer = BASE_URL + "/ShopBuyer/reactivateBuyer";
export const urlUpdateBuyer = BASE_URL + "/ShopBuyer/updateBuyer";

export const urlGetPriceTierList = BASE_URL + "/ShopBuyer/getPriceTierList";
export const urlCreatePriceTier = BASE_URL + "/ShopBuyer/createPriceTier";
export const urlUpdatePriceTier = BASE_URL + "/ShopBuyer/updatePriceTier";
export const urlDeletePriceTier = BASE_URL + "/ShopBuyer/deletePriceTier";

export const urlGetShippingZoneList = BASE_URL + "/ShopShippingZone/getZoneList";
export const urlCreateShippingZone = BASE_URL + "/ShopShippingZone/createZone";
export const urlUpdateShippingZone = BASE_URL + "/ShopShippingZone/updateZone";
export const urlDeleteShippingZone = BASE_URL + "/ShopShippingZone/deleteZone";

export const urlGetUnitList = BASE_URL + "/ShopUnit/getUnitList";
export const urlGetAllUnits = BASE_URL + "/ShopUnit/getAllUnits";
export const urlCreateUnit = BASE_URL + "/ShopUnit/createUnit";
export const urlUpdateUnit = BASE_URL + "/ShopUnit/updateUnit";
export const urlDeleteUnit = BASE_URL + "/ShopUnit/deleteUnit";

export const urlCreateUser = BASE_URL + "/Profile/createUser";
export const urlUpdateUser = BASE_URL + "/Profile/updateUser";
export const urlGetUserList = BASE_URL + "/Profile/getUserList";
export const urlDeleteUser = BASE_URL + "/Profile/deleteUser";